import React, { useState } from 'react';
import content from '../content/site-content.ko.json';
import './Contact.css';

const { contactPage } = content;

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: contactPage.subjects[0],
    message: '',
    website: '' // honeypot — leave empty
  });
  const [submitStatus, setSubmitStatus] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('sending');
    setErrorMessage('');
    try {
      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setSubmitStatus('success');
        setErrorMessage('');
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: contactPage.subjects[0],
          message: '',
          website: ''
        });
        setTimeout(() => setSubmitStatus(''), 5000);
      } else {
        setSubmitStatus('error');
        setErrorMessage(data.error || data.message || data.details || '메시지 전송에 실패했습니다.');
        setTimeout(() => {
          setSubmitStatus('');
          setErrorMessage('');
        }, 8000);
      }
    } catch (error) {
      setSubmitStatus('error');
      setErrorMessage('네트워크 오류가 발생했습니다. 연결을 확인하고 다시 시도해주세요.');
      setTimeout(() => {
        setSubmitStatus('');
        setErrorMessage('');
      }, 8000);
    }
  };

  return (
    <div className="contact-page contact-page--studio">
      <section className="contact-page-hero">
        <div className="contact-page-hero__inner">
          <p className="contact-page-hero__label">STAR612 STUDIO</p>
          <h1>{contactPage.title}</h1>
          <p>{contactPage.subtitle}</p>
        </div>
      </section>
      <div className="contact-container">
        <div className="contact-info">
          <h2>{contactPage.infoTitle}</h2>
          <p className="sub-text">{contactPage.infoText}</p>
          <ul className="contact-types">
            {contactPage.subjects.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </div>
        <div className="contact-form">
          <form onSubmit={handleSubmit}>
            <div className="hp-field" aria-hidden="true">
              <label htmlFor="contact-website">Website</label>
              <input
                type="text"
                id="contact-website"
                name="website"
                value={formData.website}
                onChange={handleChange}
                tabIndex={-1}
                autoComplete="off"
              />
            </div>
            <input type="text" name="name" placeholder="이름 (기업명)" onChange={handleChange} value={formData.name} required />
            <input type="email" name="email" placeholder="이메일" onChange={handleChange} value={formData.email} required />
            <input type="tel" name="phone" placeholder="연락처" onChange={handleChange} value={formData.phone} required />
            <select name="subject" onChange={handleChange} value={formData.subject} required>
              {contactPage.subjects.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
            <textarea name="message" placeholder="프로젝트 개요, 일정, 예산 등을 알려주세요." onChange={handleChange} value={formData.message} required />
            <button type="submit" disabled={submitStatus === 'sending'}>
              {submitStatus === 'sending' ? '전송 중...' : '견적·문의 보내기'}
            </button>
          </form>
          {submitStatus === 'success' && <p className="success-message">메시지가 성공적으로 전송되었습니다.</p>}
          {submitStatus === 'error' && (
            <p className="error-message">
              {errorMessage || '메시지 전송에 실패했습니다. 다시 시도해 주세요.'}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Contact;
